// Presets de intervalo de data para os filtros do dashboard.
// Cada preset devolve { start, end } como Date local.

const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
const endOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
const addDays = (d, n) => {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
};

// Semana começa no domingo (padrão do calendário brasileiro).
const startOfWeek = (d) => startOfDay(addDays(d, -d.getDay()));

export const DATE_PRESETS = [
  { key: 'hoje', label: 'Hoje' },
  { key: 'ontem', label: 'Ontem' },
  { key: 'essa_semana', label: 'Essa semana' },
  { key: 'ultimos_7', label: 'Últimos 7 dias' },
  { key: 'esse_mes', label: 'Esse mês' },
  { key: 'ultimos_30', label: 'Últimos 30 dias' },
  { key: 'esse_ano', label: 'Esse ano' },
];

export const DEFAULT_PRESET = 'esse_mes';

export function getPresetRange(key, now = new Date()) {
  switch (key) {
    case 'hoje':
      return { start: startOfDay(now), end: endOfDay(now) };
    case 'ontem': {
      const yesterday = addDays(now, -1);
      return { start: startOfDay(yesterday), end: endOfDay(yesterday) };
    }
    case 'essa_semana':
      return { start: startOfWeek(now), end: endOfDay(now) };
    case 'ultimos_7':
      return { start: startOfDay(addDays(now, -6)), end: endOfDay(now) };
    case 'esse_mes':
      return { start: new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0), end: endOfDay(now) };
    case 'ultimos_30':
      return { start: startOfDay(addDays(now, -29)), end: endOfDay(now) };
    case 'esse_ano':
      return { start: new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0), end: endOfDay(now) };
    default:
      return null;
  }
}
